import { render, staticRenderFns } from "./DetectReport.vue?vue&type=template&id=22eed1b2&scoped=true&"
import script from "./DetectReport.vue?vue&type=script&lang=js&"
export * from "./DetectReport.vue?vue&type=script&lang=js&"
import style0 from "./DetectReport.vue?vue&type=style&index=0&id=22eed1b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eed1b2",
  null
  
)

export default component.exports